import styles from "./styles.module.scss";

import { ResourceTagColors } from "../../constants";
import { ResourceTagProps } from "./types";
import { Badge, Tooltip } from "@altimateai/lego";

const ResourceTag = ({ resource, index = 0, onClick }: ResourceTagProps) => {
  return (
    <Badge
      style={{
        backgroundColor: ResourceTagColors[index % 3].color,
        color: ResourceTagColors[index % 3].textColor,
        width: "100%",
      }}
      onClick={
        onClick
          ? e => {
              e.stopPropagation();
              onClick(e);
            }
          : undefined
      }
    >
      <div className={styles.tag}>
        <Tooltip title={resource.resource_name}>
          <div className={styles.name}>{resource.resource_name}</div>
        </Tooltip>
      </div>
    </Badge>
  );
};

export default ResourceTag;
